import React, { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Media } from 'react-breakpoints';
import classnames from 'classnames';
import { BaseStore } from 'src/store';
import { ProductsDetailsStore } from 'src/modules/products';
import { ProductProperties, displayProductsProperty } from 'src/modules/products/details';
import { Tabs } from 'antd';
import { LayoutOverlay } from 'src/modules/layout';
import { useIntl } from 'react-intl';
import ProductsDetailsOverlaySectionDetails from './section/details/ProductsDetailsOverlaySectionDetails';
import ProductsDetailsOverlaySectionColor from './section/color/ProductsDetailsOverlaySectionColor';
import ProductsDetailsOverlaySectionDownload from './section/download/ProductsDetailsOverlaySectionDownload';
import styles from './ProductsDetailsOverlay.module.scss';
import { breakpoints } from 'src/utils/breakpoints';
import { GlobalIcon, IconImage } from 'src/modules/global';

interface ProductsDetailsOverlayProps extends ProductsDetailsStore {
  activeProductProperty: ProductProperties;
  dispatch: any;
}

const ProductsDetailsOverlay: React.FunctionComponent<ProductsDetailsOverlayProps> = (
  props: ProductsDetailsOverlayProps
) => {
  const intl = useIntl();
  const { TabPane } = Tabs;
  const {
    // product: { title, family },
    activeProductProperty,
    dispatch,
    isLoadingMaterials,
    materialColors,
  } = props;

  let activeTab: string;
  const { Details, Colors, Downloads } = ProductProperties;

  switch (activeProductProperty) {
    case Downloads:
      activeTab = '3';
      break;
    case Colors:
      activeTab = '2';
      break;
    case Details:
      activeTab = '1';
      break;
  }

  const detailsEnabled = !_.isEmpty(props?.product?.product_details_overlay);

  const materialsEnabled = isLoadingMaterials || materialColors.length;
  // props.product.product_variants?.some(
  //   (variant) => variant.materials?.length || variant.material_colors?.length
  // );

  const getTabName = (tab: string) => {
    switch (tab) {
      case '1':
        return intl.formatMessage({ id: 'page/products/details/details' });
      case '2':
        return intl.formatMessage({ id: 'page/products/details/colors_materials' });
      case '3':
        return intl.formatMessage({ id: 'page/products/details/downloads' });
    }
    return '';
  };

  const getTabContents = (tab: string) => {
    switch (tab) {
      case '1':
        return <ProductsDetailsOverlaySectionDetails />;
      case '2':
        return <ProductsDetailsOverlaySectionColor />;
      case '3':
        return <ProductsDetailsOverlaySectionDownload />;
    }
    return null;
  };

  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <LayoutOverlay
      display={!!activeProductProperty}
      onClose={() => {
        setMenuOpen(false);
        dispatch(displayProductsProperty(null));
      }}
      containerClassName={styles.overlay}
      className={styles.overlay}>
      <Media>
        {({ currentBreakpoint }) => {
          if (breakpoints[currentBreakpoint] < breakpoints.md) {
            return (
              <div className={styles.container} key={`contents-${currentBreakpoint}`}>
                <div className={styles.dropdown}>
                  <div className={styles.dropdownLabel} onClick={toggleMenu}>
                    {getTabName(activeTab)}
                    <GlobalIcon
                      image={IconImage.DownArrow}
                      rotation={isMenuOpen ? 180 : 0}
                      className={styles.dropdownIcon}
                      size="custom"
                    />
                  </div>
                  <div className={classnames(styles.dropdownMenu, isMenuOpen && styles.open)}>
                    {detailsEnabled && activeTab !== '1' && (
                      <div
                        className={styles.dropdownMenuItem}
                        onClick={() => {
                          dispatch(displayProductsProperty(ProductProperties.Details));
                          setMenuOpen(false);
                        }}>
                        {getTabName('1')}
                      </div>
                    )}
                    {materialsEnabled && activeTab !== '2' && (
                      <div
                        className={styles.dropdownMenuItem}
                        onClick={() => {
                          dispatch(displayProductsProperty(ProductProperties.Colors));
                          setMenuOpen(false);
                        }}>
                        {getTabName('2')}
                      </div>
                    )}
                    {activeTab !== '3' && (
                      <div
                        className={styles.dropdownMenuItem}
                        onClick={() => {
                          dispatch(displayProductsProperty(ProductProperties.Downloads));
                          setMenuOpen(false);
                        }}>
                        {getTabName('3')}
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.tabContents}>{getTabContents(activeTab)}</div>
              </div>
            );
          }

          return (
            <div className={styles.container} key={`contents-${currentBreakpoint}`}>
              <Tabs defaultActiveKey={activeTab}>
                {detailsEnabled && (
                  <TabPane tab={getTabName('1')} key="1">
                    {getTabContents('1')}
                  </TabPane>
                )}
                {materialsEnabled && (
                  <TabPane tab={getTabName('2')} key="2">
                    {getTabContents('2')}
                  </TabPane>
                )}
                <TabPane tab={getTabName('3')} key="3" className={styles.tabPanel}>
                  {getTabContents('3')}
                </TabPane>
              </Tabs>
            </div>
          );
        }}
      </Media>
    </LayoutOverlay>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.products.details };
};

export default connect(mapStateToProps)(ProductsDetailsOverlay);
